import type { Error } from '../types';

export const minLength =
  (min: number, message?: Error['message']) =>
  (value: string): Error => ({
    valid: !!value && value.length >= min,
    message
  });
